import { TournamentPlayerRole } from '@okletsplay/core';
import { TournamentPlayerEntity, TournamentTeamEntity } from 'app/interfaces/entity';

export function getTeamCaptain(
  team: TournamentTeamEntity | undefined
): TournamentPlayerEntity | undefined {
  return team?.players?.find((player) => player.role === TournamentPlayerRole.Captain);
}
